import React from 'react';
import {Tag} from "primereact/tag";

import {chipSeverity, chipText, chipTooltip, sellerChips} from "./sellerIdentity";

// One chip per other marketplace. The state is always visible: an automatic match never looks
// like one a person confirmed.
const SellerIdentityChips = ({t, view, marketplaces, notFoundOn, onChipClick}) => (
    <span className="seller-identity-chips" style={{display: 'flex', flexWrap: 'wrap', gap: 4}}>
        {sellerChips(view, marketplaces, notFoundOn).map(chip =>
            // Tag passes neither events nor data attributes through, so the wrapper carries them.
            <span key={chip.key} className="seller-identity-chip" data-pr-tooltip={chipTooltip(chip, t) || undefined}
                  role={onChipClick ? 'button' : undefined} tabIndex={onChipClick ? 0 : undefined}
                  onClick={onChipClick ? () => onChipClick(chip) : undefined}
                  onKeyDown={onChipClick ? (e) => e.key === 'Enter' && onChipClick(chip) : undefined}
                  style={{cursor: onChipClick ? 'pointer' : 'default'}}>
                <Tag severity={chipSeverity(chip)} value={chipText(chip, t)}
                     style={{fontWeight: 500, ...(chip.state === 'empty' ? {background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db'} : {})}}/>
            </span>)}
    </span>
);

export default SellerIdentityChips;
